import { ElMessageBox } from 'element-plus';

function prompt(options: {
  title: string;
  message: string;
  confirmButtonText?: string,
  cancelButtonText?: string
}, success: (value: string) => void) {
  ElMessageBox.prompt(options.message, options.title, {
    confirmButtonText: options.confirmButtonText || '确定',
    cancelButtonText: options.cancelButtonText || '取消',
  }).then(({ value }) => {
    if (value) {
      success(value);
    }
  });
}

export default prompt;
